import React, { useState, useEffect, useRef } from "react";
import { supabase } from "./supabaseClient";
import { getOrCreateStats, getLevelForXP, BADGES } from "./Gamification";

function ProfileCard({ user }) {
  const [profile, setProfile] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const cardRef = useRef(null);

  useEffect(() => {
    Promise.all([
      supabase.from("profiles").select("*").eq("id", user.id).single(),
      getOrCreateStats(user.id)
    ]).then(([{ data: profileData }, statsData]) => {
      setProfile(profileData);
      setStats(statsData);
      setLoading(false);
    });
  }, [user]);

  if (loading) return (
    <div style={{textAlign:"center",padding:"60px",fontFamily:"Inter, sans-serif"}}>
      <p style={{color:"#555"}}>Building your card...</p>
    </div>
  );

  const level = getLevelForXP(stats?.xp || 0);
  const earnedBadges = (stats?.badges || []).slice(0, 4).map(id => BADGES[id]).filter(Boolean);

  return (
    <div style={{fontFamily:"Inter, sans-serif"}}>
      <h2 style={{fontFamily:"Bebas Neue, sans-serif",fontSize:"2.5rem",letterSpacing:"2px",background:"linear-gradient(135deg, #e94560, #ff6b35)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",marginBottom:"10px",marginTop:0}}>FIGHTER CARD</h2>
      <p style={{color:"#555",marginBottom:"30px",fontSize:"0.9rem"}}>Screenshot and share on social media 📱</p>

      <div ref={cardRef} style={{
        background:"linear-gradient(135deg, #0a0a0f 0%, #1a0510 40%, #0a0f1a 100%)",
        borderRadius:"24px",
        padding:"35px",
        border:"1px solid rgba(233,69,96,0.3)",
        boxShadow:"0 0 60px rgba(233,69,96,0.15), inset 0 1px 0 rgba(255,255,255,0.05)",
        maxWidth:"420px",
        position:"relative",
        overflow:"hidden"
      }}>
        <div style={{position:"absolute",top:"-50px",right:"-50px",width:"200px",height:"200px",borderRadius:"50%",background:"radial-gradient(circle, rgba(233,69,96,0.2) 0%, transparent 70%)",pointerEvents:"none"}}/>
        <div style={{position:"absolute",bottom:"-50px",left:"-50px",width:"200px",height:"200px",borderRadius:"50%",background:"radial-gradient(circle, rgba(255,107,53,0.15) 0%, transparent 70%)",pointerEvents:"none"}}/>

        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"25px",position:"relative"}}>
          <div style={{display:"flex",alignItems:"center",gap:"15px"}}>
            <div style={{width:"65px",height:"65px",borderRadius:"50%",background: profile?.avatar_url ? "transparent" : "linear-gradient(135deg, #e94560, #ff6b35)",border:"3px solid rgba(233,69,96,0.5)",overflow:"hidden",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.8rem",flexShrink:0}}>
              {profile?.avatar_url ? <img src={profile.avatar_url} alt="avatar" style={{width:"100%",height:"100%",objectFit:"cover"}} /> : "🥋"}
            </div>
            <div>
              <h3 style={{margin:0,fontSize:"1.2rem",fontWeight:"700",color:"white"}}>{profile?.full_name || user.email.split("@")[0]}</h3>
              <p style={{margin:"3px 0 0 0",color:"#666",fontSize:"0.8rem",textTransform:"uppercase",letterSpacing:"1px"}}>{profile?.weight_class?.split("(")[0]?.trim() || "Fighter"}</p>
              {profile?.boxing_style && <p style={{margin:"3px 0 0 0",color:"#e94560",fontSize:"0.8rem",fontWeight:"600",textTransform:"capitalize"}}>{profile.boxing_style.replace("_", " ")}</p>}
            </div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{fontFamily:"Bebas Neue, sans-serif",fontSize:"2.5rem",background:"linear-gradient(135deg, #e94560, #ff6b35)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",lineHeight:1,letterSpacing:"1px"}}>{level.name}</div>
            <div style={{color:"#555",fontSize:"0.75rem",textTransform:"uppercase",letterSpacing:"1px"}}>Level {level.level}</div>
          </div>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"12px",marginBottom:"20px",position:"relative"}}>
          {[
            { value: stats?.xp || 0, label: "Total XP" },
            { value: stats?.streak || 0, label: "Day Streak" },
            { value: stats?.total_uploads || 0, label: "Sessions" }
          ].map(stat => (
            <div key={stat.label} style={{background:"rgba(255,255,255,0.04)",borderRadius:"12px",padding:"14px 10px",textAlign:"center",border:"1px solid rgba(255,255,255,0.06)"}}>
              <p style={{color:"white",margin:0,fontSize:"1.4rem",fontWeight:"700"}}>{stat.value}</p>
              <p style={{color:"#444",margin:"3px 0 0 0",fontSize:"0.7rem",textTransform:"uppercase",letterSpacing:"0.5px"}}>{stat.label}</p>
            </div>
          ))}
        </div>

        {earnedBadges.length > 0 && (
          <div style={{marginBottom:"20px",position:"relative"}}>
            <p style={{color:"#444",fontSize:"0.7rem",textTransform:"uppercase",letterSpacing:"1px",marginBottom:"10px"}}>Badges</p>
            <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
              {earnedBadges.map(badge => (
                <div key={badge.id} style={{background:"rgba(233,69,96,0.1)",border:"1px solid rgba(233,69,96,0.2)",borderRadius:"20px",padding:"5px 12px",display:"flex",alignItems:"center",gap:"5px"}}>
                  <span style={{fontSize:"0.9rem"}}>{badge.emoji}</span>
                  <span style={{color:"#ccc",fontSize:"0.75rem",fontWeight:"500"}}>{badge.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{borderTop:"1px solid rgba(255,255,255,0.05)",paddingTop:"15px",display:"flex",justifyContent:"space-between",alignItems:"center",position:"relative"}}>
          <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
            <span style={{fontSize:"1.1rem"}}>🥊</span>
            <span style={{fontFamily:"Bebas Neue, sans-serif",fontSize:"1rem",background:"linear-gradient(135deg, #e94560, #ff6b35)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",letterSpacing:"1px"}}>FIGHTCOACH AI</span>
          </div>
          <span style={{color:"#333",fontSize:"0.75rem"}}>fightcoach-mvp.vercel.app</span>
        </div>
      </div>

      <div style={{marginTop:"25px",display:"flex",gap:"12px",flexWrap:"wrap"}}>
        <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:"12px",padding:"15px 20px",flex:1}}>
          <p style={{color:"#555",margin:"0 0 5px 0",fontSize:"0.8rem"}}>📱 How to share</p>
          <p style={{color:"#888",margin:0,fontSize:"0.85rem",lineHeight:"1.5"}}>Take a screenshot of your card above and post it to Instagram, TikTok, or Snapchat with <span style={{color:"#e94560"}}>#FightCoachAI</span></p>
        </div>
      </div>
    </div>
  );
}

export default ProfileCard;
